import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "radio", "cardBody", "submitBtn", "ownershipModal", "ownershipModalLink"]

  select() {
    const selectedRadio = this.radioTargets.find(r => r.checked)
    if (!selectedRadio) return

    const selectedIdx = selectedRadio.value
    const selectedCard = this.cardTargets.find(c => c.dataset.slotIdx === selectedIdx)

    if (selectedCard && selectedCard.dataset.needsOwnership === "true") {
      this._showOwnershipModal(selectedCard.dataset.slotAccountId)
      selectedRadio.checked = false
      return
    }

    this.cardTargets.forEach(card => {
      const body = card.querySelector("[data-slot-selector-target='cardBody']")
      if (!body) return

      if (card.dataset.slotIdx === selectedIdx) {
        body.style.borderColor = "var(--neon-primary)"
        body.style.boxShadow = "0 0 30px var(--neon-primary-15), 0 0 60px var(--neon-primary-04)"
      } else {
        const radio = card.querySelector("input[type='radio']")
        if (radio && !radio.disabled) {
          body.style.borderColor = "var(--neon-primary-30)"
          body.style.boxShadow = "none"
        }
      }
    })

    if (!this.hasSubmitBtnTarget) return

    const btn = this.submitBtnTarget
    btn.disabled = false
    btn.style.background = "var(--neon-primary-08)"
    btn.style.color = "var(--neon-primary)"
    btn.style.borderColor = "var(--neon-primary-30)"
    btn.style.cursor = "pointer"
    btn.style.boxShadow = "0 0 20px var(--neon-primary-08)"
  }

  closeOwnershipModal() {
    if (this.hasOwnershipModalTarget) {
      this.ownershipModalTarget.classList.add("hidden")
    }
  }

  _showOwnershipModal(slotAccountId) {
    if (!this.hasOwnershipModalTarget) return

    if (this.hasOwnershipModalLinkTarget && slotAccountId) {
      this.ownershipModalLinkTarget.href = `/accounts/${slotAccountId}`
    }

    this.ownershipModalTarget.classList.remove("hidden")
  }
}
